import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/black-green-light.css';

Vue.use(VueMaterial);





import Notifications from 'vue-notification';
Vue.use(Notifications);

import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);

import Vuex from 'vuex';
Vue.use(Vuex);

import VueLocalStorage from 'vue-localstorage';

Vue.use(VueLocalStorage);
Vue.use(VueLocalStorage, {
    name: 'ls',
    bind: true
});



Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");





